import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSeller } from '../../context/SellerContext';

const SuccessModal = () => {
  const navigate = useNavigate();
  const { seller } = useSeller();

  const handleStartSelling = () => {
    navigate('/seller/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="mb-6">
          <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
            <svg
              className="w-12 h-12 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        {/* Congratulations Message */}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Congratulations!
        </h1>

        <p className="text-gray-600 text-lg mb-2">
          Welcome to the Kalinga family
        </p>

        <p className="text-gray-700 mb-8">
          You are now part of <span className="font-bold">6 lakh+ suppliers</span> community, selling all over India
        </p>

        {/* Store Name Display */}
        {seller && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
            <p className="text-sm text-gray-600 mb-1">Your Store Name</p>
            <p className="text-xl font-bold text-blue-600">{seller.storeName}</p>
          </div>
        )}

        {/* Benefits */}
        <div className="bg-gray-50 rounded-lg p-4 mb-8 text-left">
          <h3 className="font-semibold text-gray-800 mb-3">What's Next:</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Upload your product catalog</span>
            </li>
            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Add products to your store</span>
            </li>
            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Start receiving orders from customers</span>
            </li>
          </ul>
        </div>

        {/* CTA Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleStartSelling}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition duration-200 text-lg"
          >
            Start Selling Now
          </button>

          <a
            href="/seller/dashboard"
            className="block text-blue-600 hover:text-blue-700 font-semibold text-sm"
          >
            Go to Dashboard
          </a>
        </div>

        {/* Additional Info */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-sm text-gray-600">
          <p className="mb-2">Need help getting started?</p>
          <p>
            Check out our{' '}
            <a href="/learning" className="text-blue-600 hover:underline font-semibold">
              Learning Center
            </a>{' '}
            for tutorials and guides
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
